/**
 * @file PRO Admin custom prints fragments.
 */
import gql from 'graphql-tag';

import { AccountAddressFields } from './account';
import { TransactionItemDetails } from './transaction';

export const CustomPrintFields = gql`
  fragment CustomPrintFields on CustomPrint {
    id
    account {
      id
    }
    name
    type
    subtype
    width
    height
    preview_image {
      id
      url
    }
    background_image {
      id
      url
    }
    description
    photos_no
    custom_print_caption_enabled
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    shipping_required
    shipping_enabled
    requires_package_purchase
    card {
      id
      card_side_groups {
        records {
          id
          card_sides {
            records {
              id
              card_template {
                id
                orientation
                print_size {
                  id
                  name
                  width
                  height
                }
                print_product {
                  id
                  name
                  print_partner {
                    id
                    name
                  }
                  sizes(slice: { limit: 999 }) {
                    records {
                      id
                      sku
                      print_size {
                        id
                      }
                      price {
                        value
                        currency
                      }
                      min_price {
                        value
                        currency
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    album_folder_tags(slice: { limit: 999 }) {
      total
      records {
        id
        custom_print {
          id
          name
        }
        album_folder_tag {
          ... on IRecord {
            id
          }
        }
        price {
          value
          currency
        }
      }
    }
    pricing_categories(slice: { limit: 999 }) {
      total
      records {
        id
        pricing_category {
          id
          name
        }
      }
    }
    jersey_colors(slice: { limit: 999 }) {
      total
      records {
        id
        jersey_color
      }
    }
    has_pending_purchased_custom_print
    soft_deleted
    soft_deleted_at
    id_card_type
  }
`;

export const AlbumCustomPrintFields = gql`
  fragment AlbumCustomPrintFields on AlbumCustomPrint {
    id
    album {
      id
    }
    custom_print {
      id
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    shipping_enabled
    shipping_required
  }
`;

export const AlbumFolderCustomPrintFields = gql`
  fragment AlbumFolderCustomPrintFields on AlbumFolderCustomPrint {
    id
    album_folder {
      id
    }
    custom_print {
      id
      price {
        value
        currency
      }
      discount_price {
        value
        currency
      }
      shipping_price {
        value
        currency
      }
    }
  }
`;

// DO NOT USE PhotoThumbnails FRAGMENT HERE.
// This file is being used within the album fragments file and will break the app if you do that.
export const PurchasedCustomPrintFields = gql`
  fragment PurchasedCustomPrintFields on PurchasedCustomPrint {
    id
    account {
      id
      name
      phone_number
      email_address
      addresses {
        ...AccountAddressFields
      }
    }
    vendor_account {
      id
      logo_image {
        id
        url
      }
    }
    album {
      id
      name
    }
    custom_print {
      id
      name
      type
      subtype
      account_address {
        id
      }
      photos_no
      description
    }
    custom_print_type
    identity {
      id
      name
      last_name
      current_photo {
        id
        thumbnail_urls {
          url
          width
          height
          size_code
        }
      }
    }
    selected_identity {
      id
    }
    name
    preview_image {
      id
      url
    }
    background_image {
      id
      url
    }
    photos_no
    custom_print_caption_enabled
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    shipping_enabled
    shipping_required
    quantity
    discount_purchased
    shipping_purchased
    total_price {
      value
      currency
    }
    custom_print_caption
    order_status
    photos {
      records {
        asset_image {
          id
          url
        }
        photo {
          id
          original_filename
          foreground {
            original_url {
              url
            }
          }
          thumbnail_urls(ignore_watermark: true) {
            url
            width
            height
            size_code
          }
          albums(slice: { limit: 1 }) {
            records {
              id
              name
            }
          }
        }
        emoji
        position
        cropbox {
          x
          y
          scale
          rotation
        }
      }
    }
    waldogram {
      cabin_name
      identity_name
      external_shipping_address {
        id
      }
    }
    transaction {
      id
      email_address
    }
    transaction_item {
      ...TransactionItemDetails
    }
    account_card {
      account_card {
        id
        front_preview_file_download_url
        account_card_sides {
          id
          card_side {
            id
            card_template {
              id
              orientation
              print_size {
                id
                name
                width
                height
              }
            }
          }
        }
        target_account_card {
          id
          front_preview_file_download_url
          account_card_sides {
            id
            card_side {
              id
              card_template {
                id
                orientation
                print_size {
                  id
                  name
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
    vendor_configuration
    print_file_download_url
    print_file_url
    created_at
    updated_at
    shipped_at
  }
  ${AccountAddressFields}
  ${TransactionItemDetails}
`;
